export const SPAP_CHECKOUTID = 'spap-checkoutId';

export const SPAP_LOGGED_USER = 'spap-loggedUser';
